var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function getWebEncodedComponentData(target, key) {
  const strData = target.dataset[key];
  try {
    const decodedData = atob(strData);
    return JSON.parse(decodedData);
  } catch {
    return {};
  }
}

function createElementFromHTML(htmlString) {
  var div = document.createElement("div");
  div.innerHTML = htmlString.trim();

  // Change this to div.childNodes to support multiple top-level nodes.
  return div.firstChild;
}

function hasArraysSameValues(arr1, arr2) {
  return arr1.sort().join(",") === arr2.sort().join(",");
}

function findVariantByOptionValues(variants, values) {
  return variants.find((variant) => {
    return hasArraysSameValues(variant.options, values);
  });
}

function paramsToObject() {
  const urlParams = new URLSearchParams(window.location.search);
  const entries = urlParams.entries();
  const result = {};
  for (const [key, value] of entries) {
    // each 'entry' is a [key, value] tupple
    result[key] = value;
  }
  return result;
}

function insertUrlParam(key, value) {
  if (history.pushState) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    let newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      "?" +
      searchParams.toString();
    window.history.pushState({ path: newurl }, "", newurl);
  }
}

function findFirstIntersection(arr1, arr2) {
  for (let item1 of arr1) {
    if (arr2.includes(item1)) {
      return item1;
    }
  }
  return null; // Return null if there is no intersection
}

function watchPopStateChanges(callback) {
  window.addEventListener("popstate", callback);
}

class CartWorker extends HTMLElement {
  openCart() {
    document.querySelector(".flyout").classList.add("active");
    document.body.style.overflow = "hidden";
  }

  async addVariantToCart(id, quantity) {
    const formData = {
      items: [{ id: id, quantity: +quantity }],
    };

    const rawAddToCartResponse = await fetch(
      window.Shopify.routes.root + "cart/add.js",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );
    const addToCartResponse = await rawAddToCartResponse.json();

    [
      { id: "main-cart-items", selector: ".cart__items" },
      { id: "main-cart-footer", selector: ".cart__footer-inner" },
      { id: "header", selector: "#shopify-section-header" },
    ].forEach((group) => {
      fetch(`?section_id=${group.id}`)
        .then((resp) => resp.text())
        .then((state) => {
          document.querySelector(group.selector).innerHTML = state;
        });
    });

    this.openCart();
  }
}

class EducationModule extends CartWorker {
  connectedCallback() {
    this.querySelector("form").addEventListener("submit", async (e) => {
      e.preventDefault();

      const id = e.target.querySelector('[name="id"]');

      if (id) {
        this.addVariantToCart(id.value, 1);
      }
    });
  }
}

customElements.define("education-module", EducationModule);

class ProductHero extends CartWorker {
  connectedCallback() {
    this.swiper = null;
    this.swiperConfig = {
      loop: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    };
    this.productTags = getWebEncodedComponentData(this, "productTags");
    this.productVariantsInfo = getWebEncodedComponentData(
      this,
      "productVariantsInfo"
    );
    this.selectedVariantId = getWebEncodedComponentData(
      this,
      "defaultVariantId"
    );
    this.variants = getWebEncodedComponentData(this, "variants");
    if (this.variants) {
      this.selectedVariant = this.variants.find(
        (variant) => variant.id === this.selectedVariantId
      );
    }
    this.updateProductImages();

    this.initCarousel();
    this.initProductForm();
    watchPopStateChanges(this.handlePopNavigation.bind(this));
  }

  handlePopNavigation() {
    const params = paramsToObject();
    const newVariantId = params.variant;
    this.selectedVariant =
      this.variants.find((variant) => variant.id === newVariantId) ||
      this.variants[0];
    this.updateFormUI();
    this.updateColorPickerSelectedOption();
  }

  initProductForm() {
    const isCustomColorSizePicker = this.productTags.includes(
      "custom-color-size-picker"
    );

    this.addSimilarProductNavigation();
    if (isCustomColorSizePicker) {
      this.addColorPickerOptionChangeEvents();
    } else {
      this.addDefaultOptionChangeEvents();
    }

    // ATC BUTTON EVENT
    const atcButton = this.querySelector("#add-to-cart-js");
    atcButton.addEventListener("click", () => {
      const quantity = this.querySelector("#quantity-js");
      if (quantity)
        this.addVariantToCart(this.selectedVariant.id, quantity.value);
    });
  }

  addSimilarProductNavigation() {
    const similarProductNavEl = this.querySelector(
      ".option-similar-product-nav"
    );
    if (similarProductNavEl) {
      similarProductNavEl.addEventListener("change", (ev) => {
        const targetUrl = ev.target.value;
        if (targetUrl !== "no-nav") {
          window.location.href = targetUrl;
        }
      });
    }
  }

  addDefaultOptionChangeEvents() {
    const optionSelectEls = this.getOptionSelectEls();

    for (const optionSelectEl of optionSelectEls) {
      optionSelectEl.addEventListener("change", () => {
        const optionSelectEls = this.getOptionSelectEls();
        const rawValues = optionSelectEls.map((el) => el.value);
        const values = rawValues;
        const newSelectedVariant = findVariantByOptionValues(
          this.variants,
          values
        );

        const soldOutButton = this.querySelector(".sold-out");
        const atcButton = this.querySelector(".add-to-cart");
        const notifyButton = document.querySelector(".si-button.SI_trigger");
        console.log(notifyButton);
        if (!newSelectedVariant.available) {
          atcButton.classList.add("hidden");
          soldOutButton.classList.remove("hidden");
          if (notifyButton) {
            notifyButton.style.display = "block";
            notifyButton.classList.remove("hidden");
          }
        } else {
          atcButton.classList.remove("hidden");
          soldOutButton.classList.add("hidden");
          if (notifyButton) {
            notifyButton.style.display = "none";
            notifyButton.classList.add("hidden");
          }
        }

        this.selectedVariant = newSelectedVariant;
        this.updateFormUI();

        insertUrlParam("variant", newSelectedVariant.id);
      });
    }
  }

  addColorPickerOptionChangeEvents() {
    // Add Variant Option Selector Events
    const optionSelectEls = this.getOptionSelectEls();
    for (const optionSelectEl of optionSelectEls) {
      optionSelectEl.addEventListener("change", () => {
        const optionSelectEls = this.getOptionSelectEls();
        const rawValues = optionSelectEls.map((el) => el.value);
        const selectedColorButton = this.querySelector(".js-selected-option");
        const selectedColorValue = selectedColorButton.dataset.option;
        const values = [...rawValues, selectedColorValue];
        const newSelectedVariant = findVariantByOptionValues(
          this.variants,
          values
        );

        this.selectedVariant = newSelectedVariant;
        this.updateFormUI();

        insertUrlParam("variant", newSelectedVariant.id);
      });
    }

    // Add ColorKind Filter Events
    const colorKindTabButtons = Array.from(
      this.querySelectorAll(".pdp__colorkind-tab")
    );
    for (const colorKindTabButton of colorKindTabButtons) {
      colorKindTabButton.addEventListener("click", () => {
        const target = colorKindTabButton;
        const colorKind = target.dataset.value;
        const colorPickerButtons = Array.from(
          this.querySelectorAll(".color-picker-option-js")
        );

        if (this.colorKind === colorKind) {
          this.colorKind = null;
          for (const colorPickerButton of colorPickerButtons) {
            colorPickerButton.classList.remove("hidden");
          }
          target.classList.remove("bg-lime");
        } else {
          for (const colorPickerButton of colorPickerButtons) {
            const colorPickerButtonColorKind = colorPickerButton.dataset.kind;
            if (colorPickerButtonColorKind.includes(colorKind)) {
              colorPickerButton.classList.remove("hidden");
            } else {
              colorPickerButton.classList.add("hidden");
            }
          }

          for (const cktabButton of colorKindTabButtons) {
            cktabButton.classList.remove("bg-lime");
          }

          this.colorKind = colorKind;
          target.classList.add("bg-lime");
        }
      });
    }

    // Add Color Picker Events
    const colorPickerButtonEls = Array.from(
      this.querySelectorAll(".color-picker-option-js")
    );

    for (const colorPickerButton of colorPickerButtonEls) {
      colorPickerButton.addEventListener("click", () => {
        const target = colorPickerButton;
        const optionSelectEls = this.getOptionSelectEls();
        const rawValues = optionSelectEls.map((el) => el.value);
        const values = [...rawValues, target.dataset.option];
        const newSelectedVariant = findVariantByOptionValues(
          this.variants,
          values
        );

        const soldOutButton = this.querySelector(".sold-out");
        const atcButton = this.querySelector(".add-to-cart");
        const notifyButton = document.querySelector(".si-button.SI_trigger");
        console.log(notifyButton);
        if (!newSelectedVariant.available) {
          atcButton.classList.add("hidden");
          soldOutButton.classList.remove("hidden");
          if (notifyButton) {
            notifyButton.style.display = "block";
            notifyButton.classList.remove("hidden");
          }
        } else {
          atcButton.classList.remove("hidden");
          soldOutButton.classList.add("hidden");
          if (notifyButton) {
            notifyButton.style.display = "none";
            notifyButton.classList.add("hidden");
          }
        }

        this.selectedVariant = newSelectedVariant;
        this.updateFormUI();
        this.updateColorPickerSelectedOption();

        insertUrlParam("variant", newSelectedVariant.id);
      });
    }
  }

  getOptionSelectEls() {
    return Array.from(this.querySelectorAll(".select-option-js"));
  }

  updateFormUI() {
    this.updateSelectedOptionsLabels();
    this.updateSelectedOptions();
    this.updatePrices();
    this.updateShopPay();
    this.updateCarouselImages();
  }

  updateSelectedOptions() {
    const optionSelectEls = this.getOptionSelectEls();

    for (const optionSelectElIndex in optionSelectEls) {
      const optionSelectEl = optionSelectEls[optionSelectElIndex];
      const selectVals = getWebEncodedComponentData(optionSelectEl, 'values');
      if (selectVals) {
        const selectedVariantOptions = this.selectedVariant["options"];
        const newValue = findFirstIntersection(
          selectedVariantOptions,
          selectVals
        );
        optionSelectEl.value = newValue;
      }
    }
  }

  updateSelectedOptionsLabels() {
    // change field label
    const optionLabelEls = Array.from(
      this.querySelectorAll(".selected-option-label-js")
    );

    for (const optionLabelEl of optionLabelEls) {
      const optionKey = optionLabelEl.dataset.optionKey;
      if (optionKey) {
        const newLabel = this.selectedVariant[optionKey];
        optionLabelEl.innerHTML = newLabel;
      }
    }
  }

  updatePrices() {
    // change pdp-hero-prices
    const variantPrice = this.selectedVariant.price;
    const variantPriceStr = Shopify.formatMoney(variantPrice, "${{ amount }}");
    const priceTargets = Array.from(this.querySelectorAll(".price-target-js"));

    for (const priceTargetEl of priceTargets) {
      priceTargetEl.innerHTML = variantPriceStr;
    }
  }

  updateShopPay() {
    const target = this.querySelector(".shoppay-target-js");
    target.innerHTML = `
      <shop-pay-button
        class="block col-span-12 lg:col-span-8 xl:col-span-9 border border-black rounded-xl overflow-hidden"
        store-url="https://harper-ellis-hair-co.myshopify.com"
        variants="${this.selectedVariant.id}"
      ></shop-pay-button>
      `;
  }

  updateColorPickerSelectedOption() {
    const colorDescriptionContainer = document.querySelector(
      ".color-description-container-js"
    );

    const colorPickerButtonEls = Array.from(
      this.querySelectorAll(".color-picker-option-js")
    );

    const optionLabelEl = this.querySelector(".selected-color-label-js");

    for (const colorPickerButton of colorPickerButtonEls) {
      const option = colorPickerButton.dataset.option;
      if (this.selectedVariant.options.includes(option)) {
        colorPickerButton.classList.add("js-selected-option");
        colorPickerButton.classList.add("bg-lime");
        optionLabelEl.innerHTML = option;
      } else {
        colorPickerButton.classList.remove("js-selected-option");
        colorPickerButton.classList.remove("bg-lime");
      }
    }

    if (
      this.productVariantsInfo[this.selectedVariant.id].colorDescription != null
    ) {
      colorDescriptionContainer.innerHTML =
        this.productVariantsInfo[this.selectedVariant.id].colorDescription;
      colorDescriptionContainer.classList.add("block");
      colorDescriptionContainer.classList.remove("hidden");
    } else {
      colorDescriptionContainer.classList.add("hidden");
      colorDescriptionContainer.classList.remove("block");
      colorDescriptionContainer.innerHTML = "";
    }
  }

  updateCarouselImages() {
    this.swiper.destroy();
    this.swiper = null;
    this.updateProductImages();
    this.initCarousel();
  }

  updateProductImages() {
    const variantArr = this.productVariantsInfo[this.selectedVariant.id];
    if (!variantArr) {
      this.productImages = this.productVariantsInfo.default
        ? this.productVariantsInfo.default.images.slice(0, 8)
        : [];
    } else {
      this.productImages = variantArr.images.length
        ? this.productVariantsInfo[this.selectedVariant.id].images
        : this.productVariantsInfo.default
        ? this.productVariantsInfo.default.images.slice(0, 8)
        : [];
    }
  }

  initCarousel() {
    const target = this.querySelector(".gallery-target");
    target.innerHTML = "";
    const templateSelector = "#swiperProductHeroGalleryTemplate";
    const template = document.querySelector(templateSelector);
    target.innerHTML = template.innerHTML;

    this.renderBullets();
    this.renderImages();

    if (this.swiperConfig) {
      this.swiper = new Swiper(".swiper.pdp-hero-swiper", this.swiperConfig);
      this.configureBullets();
    }
  }

  renderImages() {
    const images = this.productImages;
    const target = this.querySelector(".gallery-target .swiper-wrapper");
    for (const image of images) {
      const swiperSlide = createElementFromHTML(`
        <div class="relative swiper-slide" style="padding-bottom: 90%;">
          <site-image>
            <div class="mediabox">
              <img
                src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                alt="${image.alt}"
                height="${image.height}"
                width="${image.width}"
                class="lazyload slide-image ${image.additionalClass}"
                data-lowsrc="${image.src375}"
                data-sizes="${image.sizes}"
                data-srcset="${image.src375} 375w, ${image.src550} 550w, ${image.src750} 750w, ${image.src1100} 1100w, ${image.src1500} 1500w, ${image.src1780} 1780w" />
            </div>
          </site-image>
        </div>
        `);
      target.appendChild(swiperSlide);
    }
  }

  renderBullets() {
    const images = this.productImages;
    const bulletsTarget = this.querySelector(
      ".gallery-target .carousel__pager-dots"
    );
    if (images.length < 2) return;
    for (const index in images) {
      const bullet = document.createElement("span");
      bullet.classList.add("carousel-pager");
      if (+index === 0) {
        bullet.classList.add("active");
      }
      bulletsTarget.appendChild(bullet);
    }
  }

  configureBullets() {
    const pagers = this.querySelectorAll(".carousel-pager");
    Array.from(pagers).forEach((pager, i) => {
      pager.addEventListener("click", () => {
        this.swiper.slideTo(i);
      });
    });

    this.swiper.on("slideChange", () => {
      pagers.forEach((el) => el.classList.remove("active"));
      const nextPager = pagers[this.swiper.realIndex];
      if (nextPager) nextPager.classList.add("active");
    });
  }
}

customElements.define("product-hero", ProductHero);

class ProductItem extends HTMLElement {
  connectedCallback() {
    this.swiper = null;
    this.swiperConfig = { loop: false };
    this.productTags = getWebEncodedComponentData(this, "productTags");
    this.imageOverride = getWebEncodedComponentData(this, "imageOverride");
    this.productVariantsInfo = getWebEncodedComponentData(
      this,
      "productVariantsInfo"
    );

    this.selectedVariantId = getWebEncodedComponentData(
      this,
      "defaultVariantId"
    );
    this.updateProductImages();
    this.addVariantPickerEvents();
  }

  addVariantPickerEvents() {
    const pickers = Array.from(this.querySelectorAll(".variant-picker-js"));
    const anchorContainers = Array.from(
      this.querySelectorAll(".anchor-container-js")
    );

    for (const picker of pickers) {
      picker.addEventListener("click", () => {
        pickers.forEach((el) => el.classList.remove("bg-lime"));
        picker.classList.add("bg-lime");
        this.selectedVariantId = picker.dataset.variantId;
        anchorContainers.forEach((el) => (el.href = picker.dataset.variantUrl));
        this.updateProductImages();
      });
    }
  }

  updateProductImages() {
    const variantArr = this.productVariantsInfo[this.selectedVariantId];

    if (!variantArr) {
      this.productImages = this.productVariantsInfo.default
        ? this.productVariantsInfo.default.images
        : [];
    } else {
      this.productImages = variantArr.images.length
        ? this.productVariantsInfo[this.selectedVariantId].images
        : this.productVariantsInfo.default
        ? this.productVariantsInfo.default.images
        : [];
    }
    this.renderImages();
  }

  renderImages() {
    const images = this.productImages.slice(0, 2).reverse();
    const finalImages = this.imageOverride.image
      ? [images[0], this.imageOverride.image[0]]
      : images;
    const target = this.querySelector(".image-target-js");
    target.innerHTML = "";
    for (const imageIndex in finalImages) {
      const image = finalImages[imageIndex];
      const imageEl = createElementFromHTML(`
        <site-image class="${
          finalImages.length > 1 ? "product-item-image hover:opacity-0" : ""
        }">
          <div class="mediabox">
            <img
              src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
              alt="${image.alt}"
              height="${image.height}"
              width="${image.width}"
              class="lazyload ${image.additionalClass}"
              data-lowsrc="${image.src375}"
              data-sizes="${image.sizes}"
              data-srcset="${image.src375} 375w, ${image.src550} 550w, ${
        image.src750
      } 750w, ${image.src1100} 1100w, ${image.src1500} 1500w, ${
        image.src1780
      } 1780w" />
          </div>
        </site-image>
      `);
      target.appendChild(imageEl);
    }
  }
}

customElements.define("product-item", ProductItem);

class VariantImages extends HTMLElement {
  connectedCallback() {
    const renderVariantThumbs = (rowWidth) => {
      console.log(rowWidth);
      const moreTagWidth = 56;
      const max = Math.floor((rowWidth - moreTagWidth) / 42);
      const buttons = Array.from(this.querySelectorAll('[role="button"]'));
      const moreLink = this.querySelector("a");

      buttons.forEach((button, i) => {
        button.classList.remove("hidden");
        if (i + 1 > max) {
          button.classList.add("hidden");
        }
      });
      if (max < buttons.length) {
        const p = moreLink.querySelector("p");
        moreLink.classList.remove("hidden");
        p.innerHTML = `+ ${buttons.length - max} more`;
      }
    };

    const rowWidth = this.getBoundingClientRect().width;
    renderVariantThumbs(rowWidth);

    window.addEventListener("resize", () => {
      const rowWidth = this.getBoundingClientRect().width;
      renderVariantThumbs(rowWidth);
    });
  }
}
customElements.define("variant-images", VariantImages);
